<script setup lang="ts">
import AmbassadorSignupWizard from '@/components/ambassador-signup/AmbassadorSignupWizard.vue';
</script>

<template>
  <AmbassadorSignupWizard />
</template>
